var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "schedule-group-single-icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 11C13.5069 11 13.9719 11.4477 13.9988 12.0107L14 12.0622V12.25C14 13.1889 13.5146 13.8917 12.7699 14.345C12.0377 14.7908 11.0535 15 10 15C8.94652 15 7.96227 14.7908 7.23005 14.345C6.50798 13.9055 6.02966 13.2312 6.00133 12.3347L6 12.25V12.0622C6 11.4926 6.44824 11.0281 7.01101 11.0012L7.06247 11H12.9375ZM10 5C11.3807 5 12.5 6.11929 12.5 7.5C12.5 8.8807 11.3807 10 10 10C8.6193 10 7.5 8.8807 7.5 7.5C7.5 6.11929 8.6193 5 10 5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleSchedule);
export default __webpack_public_path__ + "static/media/single_schedule.6185da5aefb7e052903e85ae72e71158.svg";
export { ForwardRef as ReactComponent };